import { usePrices } from '../hooks/use-prices'
import { Skeleton } from '@/components/ui/skeleton'
import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import Decimal from 'decimal.js'
import { IS_TESTNET } from '@/constants/walletConnectionConfig'

export default function PriceTracker() {
	const { prices, isLoading, error } = usePrices()

	if (error) {
		return (
			<Alert variant="destructive">
				<AlertCircle className="h-4 w-4" />
				<AlertDescription>
					Failed to fetch prices. Using fallback values.
				</AlertDescription>
			</Alert>
		)
	}

	if (isLoading) {
		return (
			<div className="space-y-3">
				{Array(3)
					.fill(0)
					.map((_, i) => (
						<Skeleton key={i} className="h-[72px] rounded-2xl" />
					))}
			</div>
		)
	}

	const tokens = [
		{
			name: "SECH",
			icon: "S",
			price: prices?.sech,
			color: "bg-yellow-100 text-yellow-800"
		},
		{
			name: "Ethereum",
			icon: "E",
			price: prices?.eth,
			color: "bg-blue-100 text-blue-800"
		},
		{
			name: "Tether USD",
			icon: "T",
			price: prices?.usdc,
			color: "bg-green-100 text-green-800"
		}
	]

	return (
		<ul className="market-list flex flex-col gap-1">
			{tokens.map((token, index) => (
				<TokenCard key={index} token={token} />
			))}
		</ul>
	)
}

function TokenCard({ token }: { token: any }) {
	// Don't render if no price data
	if (!token.price) {
		return null
	}

	const formattedPrice = new Decimal(token.price)
		.toFixed(IS_TESTNET ? 6 : 2)
		.toString()

	return (
		<li className="market-item h-[52px] flex items-center justify-between px-2 bg-[#212124] rounded-[8px]">
			<div className="token flex gap-2 items-center">
				<span
					className={`token-icon h-8 w-8 rounded-full flex items-center justify-center text-[#ffffff] bg-[rgba(255,255,255,0.1)]`}
					aria-hidden="true"
				>
					<span className='text-[16px] leading-[11px] font-medium font-figtree'>{token.icon}</span>
				</span>

				<span className="token-name text-xs leading-4 font-medium font-figtree text-[#ffffff]">
					{token.name}
				</span>
			</div>

			<data
				className="token-price text-xs leading-4 font-medium font-figtree text-[#ffffff]"
				value={formattedPrice}
			>
				${formattedPrice}
			</data>
		</li>

	)
}